import apiClient from "../../../../utils/interceptor";
import { API_URLS } from "../../../../constants";

// Get all machines
export const getAllMachines = async () => {
    try {
        const response = await apiClient.get(
            API_URLS.MACHINE.GET_MACHINES
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching machines:", error);
        throw error;
    }
};

// Get company yard machines
export const getCompanyYardMachines = async (params) => {
    try {
        const response = await apiClient.post(
            API_URLS.MACHINE.GET_COMPANY_YARD_MACHINES,
            params
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching company yard machines:", error);
        throw error;
    }
};

// Attach machine to company
export const attachMachine = async (attachParams) => {
    try {
        const response = await apiClient.post(
            API_URLS.MACHINE.ATTACH_MACHINE,
            attachParams
        );
        return response.data;
    } catch (error) {
        console.error("Error attaching machine:", error);
        throw error;
    }
};

// Detach machine from company
export const detachMachine = async (companyId) => {
  try {
    const response = await apiClient.delete(
      `${API_URLS.MACHINE.DETACH_MACHINE}/${companyId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error detaching machine:", error);
    throw error;
  }
};

